import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { PaymentMethodsService } from '../../../core/services/payment/payment-methods/payment-methods.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { PaymentMethodsClientEditFormComponent } from './payment-methods-client-form/payment-methods-client-edit-form.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { ContactClientEditFormComponent } from '../../contact/contact-client-edit/contact-client-form/contact-client-edit-form.component'
import { MatDivider } from '@angular/material/divider'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { TelefonePipe } from '../../../shared/pipes/phone.pipes'

@Component({
  selector: 'payment-methods-client-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    PaymentMethodsClientEditFormComponent,
    MatProgressBar,
    ContactClientEditFormComponent,
    MatDivider,
    FormClientSearchComponent,
    TelefonePipe,
  ],
  templateUrl: './payment-methods-client-edit.component.html',
  styleUrl: './payment-methods-client-edit.component.scss',
  providers: [PaymentMethodsService],
  standalone: true,
})
export class PaymentMethodsClientEditComponent
  implements OnInit, AfterViewInit
{
  constructor(
    private paymentMethodService: PaymentMethodsService,
    private snackbar: SnackbarCustomService,
  ) {}

  item: any = {}
  loading: boolean = true

  @Output() response: EventEmitter<any> = new EventEmitter()
  @Input() idPerson: number = 0
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'paymentType',
      key: 'tipoPagamento',
      description: 'Tipo pagamento',
    },
    {
      keyColumn: 'term',
      key: 'prazo',
      description: 'Prazo',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  page: number = 1
  rows: number = 10
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = ['paymentType', 'term', 'action']

  inputSearchPayment: any = { type: '', search: '' }
  listSearch: any = [
    {
      id: 'tipoPagamentoId',
      description: 'Tipo pagamento',
      type: 'number',
      visible: false,
    },
    { id: 'prazo', description: 'Prazo', type: 'string', visible: true },
  ]
  searchForm: any = { search: false, model: {} }

  ngOnInit(): void {
    this.getPaymentMedthodsByPerson()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    // if (this.table) {
    //   this.table.renderRows()
    // }
  }

  pageChanged($event: any) {
    this.page = $event.pageIndex + 1
    // this.rows = $event.pageSize
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchPaymentMedthods()
    } else {
      this.getPaymentMedthodsByPerson()
    }
  }

  getPaymentMedthodsByPerson() {
    this.loading = true
    this.paymentMethodService
      .listPagedPaymentMethodsByPerson(this.idPerson, this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchPaymentMedthods() {
    this.loading = true
    this.paymentMethodService
      .searchPagedPaymentMethods(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push({
          ...item,
        })
      }
    }
    this.tableSource = new MatTableDataSource<any>(list)
    this.refreshTable()
  }

  responseForm(response: any): void {
    if (response.refresh) {
      this.uploadList()
    }
    if (response.clear) {
      this.clearItem()
    }
  }

  updateItem(element: any) {
    this.item = { edit: true, data: element }
  }

  deleteItem(element: any) {
    this.clearItem()
    this.paymentMethodService
      .removePaymentMethod({ id: element.id })
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.uploadList()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  clearItem() {
    this.item = {}
  }

  createModel(element: any) {
    let model: any = { pessoaId: this.idPerson }
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }
}
